import { useEffect } from 'react'
import { StyledVehicleDetailImage } from './VehicleDetailImage.style'

interface IProps {
  lowRes: string[]
  thumbnail: string
  error: boolean
  vin: string
}

export const FyusionDetailImage = ({ thumbnail, lowRes, error, vin }: IProps) => {
  const prismData = lowRes.map((lowResItem) => ({
    category: '',
    src: {
      thumbnail: lowResItem,
      lowRes: lowResItem
    },
    description: ''
  }))

  useEffect(() => {
    const viewerId = `fyuse_viewer_${vin}`

    const viewerElement = document.getElementById(viewerId)
    if (viewerElement) {
      viewerElement.innerHTML = ''
    }

    ;(window as any).SVFyusion.addViewer(prismData, viewerId)

    // Cleanup function to remove viewer when component unmounts or vin changes
    return () => {
      if (viewerElement) {
        viewerElement.innerHTML = ''
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vin, thumbnail])

  return (
    <StyledVehicleDetailImage>
      {error ? (
        <img src={`content/img/AwaitingCarImage.png`} alt="Awaiting Car" />
      ) : (
        <div id={`fyuse_viewer_${vin}`}></div>
      )}
    </StyledVehicleDetailImage>
  )
}
